// noinspection DuplicatedCode
// noinspection DuplicatedCode

import {hideLoading, showLoading} from "../loading";
import {waitUntil} from "../waitUntil";
import createElement from "../createElement";

// noinspection JSUnusedGlobalSymbols -- Imported via d.ts file
/**
 * @param {ModalV2.ModalConfig|ModalV2.ModalV2} modal
 * @return {ModalV2.ModalV2}
 */
function createModalV2(modal) {
	// Create empty initializer function if missing
	// noinspection DuplicatedCode
	if (!modal.init) {
		modal.init = function () {
		};
	}

	if (!modal.modalContainer) {
		modal.modalContainer = createEmptyModal();
	}

	// Add replace function
	modal.replace = function (newModal, inPlace, preserveScrollPosition = false) {
		let scrollHistoryMap = {};
		if (preserveScrollPosition) {
			// Save vertical scroll position,
			// We trust that the position of the elements will be more or less
			// the same on the DOM tree, so we can restore the vertical scrolling
			// after loading the element back to the DOM
			scrollHistoryMap = {};
			iterateChildren(this.modalContainer, (element, id) => {
				if (element.scrollTop > 0 || element.scrollLeft) {
					scrollHistoryMap[id] = {
						top: element.scrollTop,
						left: element.scrollLeft,
					};
				}
			})
		}

		// If we are replacing in place and there
		// is an existing modal already setup
		if (inPlace && this.modalContainer.querySelector('.modal-content')) {
			// Replace the modal content only
			this.modalContainer.querySelector('.modal-content')
				.replaceWith(newModal.querySelector('.modal-content'))

			this.init(modal);
		} else {
			// Fully replace the modal
			const oldModalContainer = this.modalContainer;

			// Replace on memory and initialize
			this.modalContainer = newModal;
			this.init(modal);

			// Replace on dom
			oldModalContainer.replaceWith(this.modalContainer);
		}

		if (preserveScrollPosition) {
			// Restore vertical scroll position
			iterateChildren(this.modalContainer, (element, id) => {
				if (scrollHistoryMap[id]) {
					element.scrollTop = scrollHistoryMap[id].top;
					element.scrollLeft = scrollHistoryMap[id].left;
				}
			})
		} else {
			// Scroll to the top
			setTimeout(() => {
				iterateChildren(this.modalContainer, element => {
					element.scrollTop = 0;
					element.scrollLeft = 0;
				})
			}, 16)
		}

		// Set back button behavior if possible
		setupBackButton();
	}

	// Add loading helpers
	modal.showLoading = () => {
		showLoading(modal.modalContainer.querySelector('.modal-content'));
	};

	modal.hideLoading = () => {
		hideLoading(modal.modalContainer.querySelector('.modal-content'));
	};

	// Initialize for first time if required
	if (modal.modalContainer.classList.contains('empty-modal') === false) {
		modal.init(modal);
	}

	// Add display and hide helpers
	modal.display = function (firstTime = true) {
		waitUntil(canDisplayModal, {
			msBetweenAttempts: 50,
		}).then(() => {
			$(this.modalContainer).modal('show');

			waitUntil(() => {
				return this.modalContainer.classList.contains('show');
			}).then(() => {
				if (firstTime) {
					if (modal.onDisplay) {
						modal.onDisplay();
					} else if (firstTime) {
						// Scroll to top by default
						this.modalContainer.querySelector('.modal-body').scrollTop = 0;
					}
				}
			})
		})
	}

	// noinspection DuplicatedCode
	modal.hide = function () {
		$(this.modalContainer).modal('hide');
	}

	// Add listeners functions
	const successListeners = [];

	modal.addSuccessListener = listener => {
		successListeners.push(listener)
	}

	modal.notifySuccessListeners = (data = undefined) => {
		successListeners.forEach(listener => {
			listener(modal, data)
		})
	}

	modal.handleFormSubmit = (data, form) => {
		if (modal.onSuccess) {
			modal.onSuccess(data, form)
		}
	}

	return modal;

	/**
	 * Methods
	 */

	function createEmptyModal() {
		const modalsContainer = document.querySelector('.modals')

		const newModal = createElement('<div class="modal fade empty-modal"></div>')

		modalsContainer.appendChild(newModal);

		return newModal;
	}

	// We don't want to display the modal if a loading overlay is active
	// or another modal is loading so we use this to check it
	function canDisplayModal() {
		const loadingOverlay = document.querySelector('.loading');

		// noinspection UnnecessaryLocalVariableJS
		const loadingOverlayActive = loadingOverlay && loadingOverlay.style.display === 'block';

		// TODO: 	Check if another modal is loading
		// 			And try to add a delay after loading screen is gone
		return !loadingOverlayActive
	}

	/**
	 * Iterates recursively through all the children assigning an id
	 * to each child based on its position on the tree
	 *
	 * @param {Element} element
	 * @param {(element: Element,id: string) => void} handleChild
	 * @param id
	 */
	function iterateChildren(element, handleChild, id = '0') {
		handleChild(element, id);

		let index = 0;
		for (const child of element.children) {
			iterateChildren(child, handleChild, `${id}.${index}`);
			index++;
		}
	}

	function setupBackButton() {
		const backButton = modal.modalContainer.querySelector('.back-button');

		if (backButton) {
			backButton.addEventListener('click', () => {
				modal.hide();

				if (modal.onBackRequest) {
					modal.onBackRequest();
				}
			})
		}
	}
}

export {createModalV2}
